import { Controller } from 'stimulus';
import { useDispatch, useResize } from 'stimulus-use';
import { getBreakpointValue, getCurrentBreakpoint, isMinBreakpoint } from '../tailwindhelpers';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindconfig from '../../../tailwind.config';


const fullConfig = resolveConfig(tailwindconfig);

export default class extends Controller {
  static targets = [ 'main', 'side', 'image' ];

  connect() {
    useResize(this);
    this.writeImagesHeightWidth();
  }

  resize({ height, width}) {
    this.writeMainWidth(height, width);
    this.writeObjectFit();
  }

  writeMainWidth(height, width) { 
    if (isMinBreakpoint(width, 'md')) {
      const arWidth = (this.mainTarget.getBoundingClientRect().height / 9) * 16;
      const maxWidth = width * .76;
      this.mainTarget.style.width = `${arWidth > maxWidth ? maxWidth : arWidth}px`; 
    } else {
      this.mainTarget.style.width = ''; 
    }
  }

  getViewPortAspectRatio() {
    return window.innerWidth / window.innerHeight;
  }

  writeObjectFit() {
    if (window.innerWidth / window.innerHeight >= 16/10) {
      this.imageTargets.forEach((el) => {
        el.style.objectFit = 'cover';
      }) 
    } else {
      this.imageTargets.forEach((el) => {
        el.style.objectFit = 'contain';
      }) 
    }
  }

  writeImagesHeightWidth() {
    this.imageTargets.forEach(el => {
      el.style.height= '100%';
      el.style.width= '100%';
    })
  }

  get isMaxWidth() {
    return this.mainTarget.getBoundingClientRect().width >= window.innerWidth * .8;
  }
} 
